import { platformIncludesGoogle, platformIncludesMeta } from '../platform'
import { GoogleCampaignType } from 'components/Recommendations/EventCampaigns/Steps/Setup/Goals/campaignType'
import { MEDIA_SLOT_RATIOS } from './media'

// Google Display doesn't support 4:5. Google-only drops 9:16 too (2 exact
// slots); with Meta also selected, 9:16 is required to cover Meta's Reels
// placement (3 exact slots).
export const GOOGLE_DISPLAY_ONLY_SLOT_RATIOS = ['1:1', '1.91:1']
export const GOOGLE_DISPLAY_WITH_META_SLOT_RATIOS = ['1:1', '9:16', '1.91:1']
// Google Demand Gen supports every canonical ratio — 4 exact slots,
// regardless of whether Meta is also selected.
export const GOOGLE_DEMAND_GEN_SLOT_RATIOS = ['1:1', '9:16', '4:5', '1.91:1', ]

// Meta-only keeps the existing 2-slot feed/reel model unchanged
// (MEDIA_SLOT_RATIOS) — Google requires a larger, exact-ratio slot set once
// selected, per campaign type. googleCampaignType is ignored when Google
// isn't part of the platform selection.
export function getRequiredSlotRatios(platform, googleCampaignType) {
  if (!platformIncludesGoogle(platform)) {
    return MEDIA_SLOT_RATIOS
  }

  if (googleCampaignType === GoogleCampaignType.demandGen) {
    return GOOGLE_DEMAND_GEN_SLOT_RATIOS
  }

  return platformIncludesMeta(platform)
    ? GOOGLE_DISPLAY_WITH_META_SLOT_RATIOS
    : GOOGLE_DISPLAY_ONLY_SLOT_RATIOS
}

// Ratios Google itself actually needs to be exact — a subset of
// getRequiredSlotRatios(). Display's 9:16 slot only exists in the required
// set to cover Meta's Reels placement (see GOOGLE_DISPLAY_WITH_META_SLOT_RATIOS
// above); Google Display never uses it, so it must never be held to an
// exact-ratio standard. Demand Gen has no such Meta-only slot — every ratio
// it requires is genuinely a Google requirement, with or without Meta.
export function getGoogleExactRatios(platform, googleCampaignType) {
  if (!platformIncludesGoogle(platform)) {
    return []
  }

  return googleCampaignType === GoogleCampaignType.demandGen
    ? GOOGLE_DEMAND_GEN_SLOT_RATIOS
    : GOOGLE_DISPLAY_ONLY_SLOT_RATIOS
}
